export default "__VITE_ASSET__DdtjbHrT__"